import { useEffect } from 'react'

type Procedure = (...args: unknown[]) => void

function debounce<F extends Procedure>(func: F, delay: number) {
  let timer: ReturnType<typeof setTimeout> | null

  return function (this: ThisParameterType<F>, ...args: Parameters<F>) {
    if (timer) clearTimeout(timer)

    timer = setTimeout(() => {
      func.apply(this, args)
    }, delay)
  }
}

//TODO: this needs to be moved to blueprint repo
export const useResizeObserver = <T extends HTMLElement>(
  elementToObserve: T | null | undefined,
  resizeFn: (el: T) => void,
  options?: {
    enabled?: boolean
    debounceInterval?: number | null
  }
): void => {
  useEffect(() => {
    if (elementToObserve && options?.enabled !== false) {
      resizeFn(elementToObserve)
      const debouncedListener = options?.debounceInterval
        ? debounce(() => resizeFn(elementToObserve), options.debounceInterval)
        : () => resizeFn(elementToObserve)
      const resizeObserver = new ResizeObserver(debouncedListener)
      resizeObserver.observe(elementToObserve)
      return () => {
        resizeObserver.unobserve(elementToObserve)
        resizeObserver.disconnect()
      }
    }
  }, [elementToObserve, resizeFn, options?.debounceInterval, options?.enabled])
}
